import { fullPageRedirect } from '@hungryroot/environment';
import { log } from '@hungryroot/o11y';
import { ROUTE_CYO } from '@hungryroot/page-cyo';
import {
  serverPersist,
  ROUTE_QUIZ_INTRO,
  ROUTE_SWEETS_FREQUENCY,
  loadQuizFromLocalStorage,
  clearQuizLocalStorage,
  type Quiz,
} from '@hungryroot/quiz';
import { type SignupResponse } from '@hungryroot/rest/api/signup/post';
import {
  funnelAnalytics,
  segmentAnalytics as analytics,
} from '@hungryroot/segment';

export async function onSignupSuccess(
  customerId: number,
  redirectUrl: string = ROUTE_CYO,
  signupResponse: SignupResponse,
  signupMethod: 'email' | 'facebook' | 'apple' | 'google',
  backRedirectUrl?: string
) {
  const segment = funnelAnalytics();
  // Call analytics.identify immediatly after successful signup so userId is available for Completed Registration event.
  analytics.identify(`${customerId}`, {
    email: signupResponse.email,
    method: signupMethod,
  } as object);

  segment.completedRegistration(signupResponse, signupMethod);

  // this scenario could happen on intentional sign up or on any login page where a user believes
  // they have an account already
  const quiz = loadQuizFromLocalStorage();
  log('signup', {
    provider: signupMethod,
    quiz,
  });

  // if the user is redeeming a gift card, they can skip the quiz until after they finish redeeming
  const redirectingToRedeemGiftCard = redirectUrl.includes('redeem');
  if (redirectingToRedeemGiftCard) {
    return fullPageRedirect(redirectUrl);
  }

  // if there's no quiz data, force the user to go do it
  if (quiz === null) {
    log('quiz_null', {
      description: 'Signing up while quiz is null, reloading page',
    });
    return fullPageRedirect(ROUTE_QUIZ_INTRO);
  }

  // if there is quiz data already, go to CYO
  await persistAndRedirect(customerId, quiz, redirectUrl, backRedirectUrl);
}

async function persistAndRedirect(
  customerId: number,
  quiz: Quiz,
  redirectUrl: string,
  backRedirectUrl?: string
) {
  await serverPersist(customerId, quiz);

  // Clear quiz local storage
  clearQuizLocalStorage();

  // not sure what this logic is supposed to do -- putting the user on the sweets frequency page
  // and then be redirected to CYO? so they can press back and answer questions again?

  history.replaceState(
    undefined,
    document.title,
    backRedirectUrl || ROUTE_SWEETS_FREQUENCY
  );
  return fullPageRedirect(redirectUrl);
}
